// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","443":"about"}[chunkId] + "-legacy." + {"176":"e7ab7d42","443":"0598d7ce"}[chunkId] + ".js";
};